import { useState } from 'react';
import { useSubmitChangeSet } from '@/hooks/useFrameworkChanges';

export function SubmitChangeSetModal({
  changeSetId,
  itemCount,
  onClose,
  onSubmitted,
  submitChangeSet,
}: {
  changeSetId: string;
  itemCount: number;
  onClose: () => void;
  onSubmitted: () => void;
  submitChangeSet: ReturnType<typeof useSubmitChangeSet>;
}) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async () => {
    if (!title.trim()) {
      alert('Title is required');
      return;
    }
    try {
      await submitChangeSet.mutateAsync({
        id: changeSetId,
        title: title.trim(),
        description: description.trim() || undefined,
      });
      onSubmitted();
    } catch (e) {
      const err = e as { message?: string };
      alert(`Failed to submit: ${err.message || 'unknown error'}`);
    }
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog max-w-lg">
        <div className="dialog-header">
          <h2 className="dialog-title">Submit {itemCount} change{itemCount === 1 ? '' : 's'} for review</h2>
        </div>
        <div className="dialog-body space-y-4">
          <p className="text-sm text-gray-600">
            Once submitted, an approver will review the diff and impact analysis. Changes only apply to live data after approval.
          </p>
          <div>
            <label className="label">Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="input mt-1 w-full"
              placeholder="e.g., Q2 framework refresh"
              autoFocus
            />
          </div>
          <div>
            <label className="label">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="input mt-1 w-full"
              rows={4}
              placeholder="Why are these changes being made?"
            />
          </div>
        </div>
        <div className="dialog-footer">
          <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
          <button
            type="button"
            onClick={handleSubmit}
            className="btn-primary"
            disabled={submitChangeSet.isPending || !title.trim()}
          >
            {submitChangeSet.isPending ? 'Submitting\u2026' : 'Submit for review'}
          </button>
        </div>
      </div>
    </div>
  );
}
